import store from '../store'

export function setFilterParams(startParams?: string): string {
  const rooms = []
  const filterData: any = store.getState().layouts.filters
  let filterPath = startParams ? startParams : ''
  let first = startParams ? false : true

  if (startParams) {
    filterPath += '&page_size=10000'
  }

  for (const key in filterData) {
    if (filterData[key] && key !== 'rooms') {
      const value = filterData[key]

      filterPath += first ? `?${key}=${value}` : `&${key}=${value}`
      first = false
    } else if (filterData[key]) {
      const roomsData = filterData[key]

      for (const room in roomsData) {
        if (roomsData[room]) {
          if (roomsData[room]) rooms.push([room])
        }
      }

      if (rooms.length) {
        const roomsValue = rooms.join('-or-')
        filterPath += first ? `?${key}=${roomsValue}` : `&${key}=${roomsValue}`
        first = false
      }
    }
  }

  return filterPath
}
